import script from "./ContratosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContratosView.vue?vue&type=script&setup=true&lang=js"

import "./ContratosView.vue?vue&type=style&index=0&id=2416607e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2416607e"]])

export default __exports__